/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElCheckboxGroup as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/checkbox-group/style/css';
import { ElCheckbox as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElRow as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElInput as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElCol as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSwitch as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2630481d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "协议弹窗开关", -1));
const _hoisted_3 = {
  class: "flex items-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "登录协议开关", -1));
const _hoisted_5 = {
  class: "flex items-center"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生效条件", -1));
const _hoisted_7 = {
  class: "grid-col"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 3,
  class: "flex flex-col",
  style: {
    "padding": "0 26px"
  }
};
const _hoisted_10 = {
  key: 7
};
const _hoisted_11 = {
  class: "dialog-footer"
};
import { apiUsdkBatchSetAgreementSwitch, apiUsdkBatchAgreement } from '@/api/usdk';
import { UseDefaultAgreement, UseSwitchCommon, UseUploadText } from '../hooks';
import { UseGlobalConfig } from '@/utils/hooks';
import { useUserStore } from '@/store/modules/user';
import { storeToRefs } from 'pinia';
export default /*#__PURE__*/_defineComponent({
  __name: 'setAgreement',
  props: {
    gid: {
      type: [Number, String],
      default: ''
    },
    permissionList: {
      type: Array,
      default: () => []
    },
    sdkGameInfo: {
      type: Object,
      default: null
    },
    cids: {
      type: Array,
      default: () => []
    },
    tableSelected: {
      type: Array,
      default: () => []
    }
  },
  emits: ['ok'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const {
      keyDict
    } = UseDefaultAgreement();
    const switchForm = ref({
      privateSwitch: 0,
      userSwitch: 0,
      childSwitch: 0,
      logoffSwitch: 0,
      sdkAgrSwitch: 0
    });
    const dialogVisible = ref(false);
    const {
      userInfo
    } = storeToRefs(useUserStore());
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const {
      $channel
    } = UseGlobalConfig();
    const dict = {
      switch: '批量协议开关',
      agreement: '批量配置协议',
      batchRoot: '批量权限',
      logoff: '批量注销协议'
    };
    const form = ref();
    // const oldVersion = ref(0);
    const setRoot = ref(false);
    const cname = ref('');
    const type = ref('channel');
    const typeTitle = ref('switch');
    const currentChannel = ref('');
    const title = computed(() => {
      return dict[typeTitle.value];
    });
    // 提升版本
    const updateVersion = () => {
      let version = form.value.version;
      form.value.version = Number(Number(version || 0) + 0.1).toFixed(1);
    };
    const {
      saveSwitch
    } = UseSwitchCommon();
    const {
      batchUploadCdnText
    } = UseUploadText();
    // 单个渠道修改
    const singleChannel = () => {
      // 单个配置
      let params = {
        cid: form.value.cid,
        gid: props.gid,
        sw_key: 'sw_login_agr',
        sw_status: form.value.switch,
        sw_login_protocol: form.value.loginProtocol,
        sw_condition: {}
      };
      keyDict.forEach(key => {
        params.sw_condition[key] = form.value[key];
      });
      let p = '';
      try {
        p = form.value.p.join(',');
      } catch (error) {
        console.log(error);
      }
      saveSwitch({
        ...params,
        sw_condition: JSON.stringify({
          ...params.sw_condition,
          p
        })
      }, () => {
        emits('ok');
        batchUploadCdnText([params.cid], props.gid, props.sdkGameInfo.productID);
        handleClose();
      });
    };
    // 批量修改开关
    const batchSwitch = () => {
      apiUsdkBatchSetAgreementSwitch({
        gid: props.gid,
        cids: props.cids.join(','),
        status: form.value.switch,
        agreements: JSON.stringify({
          conditions: {
            andOr: '&&',
            conditions: form.value.conditions && form.value.conditions.conditions
          }
        })
      }).then(res => {
        if (res.code === 0) {
          emits('ok');
          handleClose();
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    // 批量修改协议
    const batchAgreement = async () => {
      var _comForm$value;
      const dict = {
        priAgrName: {
          name: 'priAgrName',
          url: 'priAgrUrl',
          type: 0
        },
        userAgrName: {
          name: 'userAgrName',
          url: 'userAgrUrl',
          type: 1
        },
        childAgrName: {
          name: 'childAgrName',
          url: 'childAgrUrl',
          type: 2
        },
        sdkAgrName: {
          name: 'sdkAgrName',
          url: 'sdkAgrUrl',
          type: 3
        },
        batchRoot: {
          name: '',
          url: '',
          type: 4
        },
        woffAgrName: {
          name: 'woffAgrName',
          url: 'woffAgrUrl',
          type: 6
        }
      };
      console.log('typeTitle', typeTitle.value);
      let p = typeTitle.value === 'batchRoot' ? form.value.p && form.value.p.length && form.value.p.join(',') : '';
      (_comForm$value = comForm.value) === null || _comForm$value === void 0 ? void 0 : _comForm$value.validate(async valid => {
        if (valid) {
          let agreementList = [];
          for (const key in form.value) {
            if (form.value[key] && dict[key]) {
              agreementList.push({
                gid: props.gid,
                cids: props.cids.join(','),
                agreements: {
                  [dict[key].name]: form.value[dict[key].name],
                  [dict[key].url]: form.value[dict[key].url]
                },
                type: dict[key].type,
                userId: userInfo.value.Id
              });
            }
          }
          confirmLoading.value = true;
          const res = await apiUsdkBatchAgreement({
            agreementList: JSON.stringify(agreementList)
          });
          if (res.code === 0) {
            emits('ok');
            batchUploadCdnText(props.cids, props.gid, props.sdkGameInfo.productID);
            handleClose();
          }
          confirmLoading.value = false;
        }
      });
      // apiUsdkBatchSetAgreement({
      // 	gid: props.gid,
      // 	cids: cids.join(','),
      // 	type: map[_type].type,
      // 	agreements: JSON.stringify({ ...agreement, p, swPermission: form.value.swPermission })
      // }).then(res => {
      // 	debugger;
      // 	if (res.code === 0) {
      // 		emits('ok');
      // 		batchUploadCdnText(props.cids, props.gid, props.sdkGameInfo.productID);
      // 		handleClose();
      // 	}
      // }).finally(() => {
      // 	confirmLoading.value = false;
      // });
    };

    function compareObjects(obj1, obj2) {
      const keys1 = Object.keys(obj1).filter(key => key !== 'switch' && key !== 'version' && key !== 'loginProtocol');
      const keys2 = Object.keys(obj2).filter(key => key !== 'switch' && key !== 'version' && key !== 'loginProtocol');
      if (keys1.length !== keys2.length) {
        return false;
      }
      return keys1.every(key => {
        if (Object.prototype.toString.call(obj1[key]) === '[object Array]' || Object.prototype.toString.call(obj1[key]) === '[object Object]') {
          return JSON.stringify(obj1[key]) === JSON.stringify(obj2[key]);
        } else {
          if (obj1[key] === obj2[key]) {
            return true;
          }
        }
      });
    }
    // 保存
    const confirmLoading = ref(false);
    const comForm = ref();
    const handleSubmit = () => {
      comForm.value.validate(valid => {
        if (valid) {
          // if (JSON.stringify(deepForm.value) === JSON.stringify(form.value)) {
          // 	ElMessage.warning('未做任何修改');
          // 	return;
          // }
          let flag = false;
          props.tableSelected && props.tableSelected.forEach(item => {
            if ($channel.GLOBAL.includes(item.channel)) {
              flag = true;
            }
          });
          const fn = () => {
            if (!compareObjects(deepForm.value, form.value) && deepForm.value.version === form.value.version) {
              // 有改动自动提示版本号
              updateVersion();
            }
            // 暂时这样 只有一种情况
            // this.form.conditions.andOr = '&&';
            confirmLoading.value = true;
            if (type.value === 'batch') {
              console.log(typeTitle);
              // 批量开关
              if (typeTitle.value === 'switch') {
                batchSwitch();
              } else {
                batchAgreement();
              }
            } else {
              singleChannel();
            }
            confirmLoading.value = false;
          };
          if (flag) {
            ElMessageBox.confirm('当前页面只支持配置国内渠道的注销协议。如需配置海外渠道的注销协议，请前往「官方全球渠道配置」下的「协议配置」。', '提示', {
              confirmButtonText: '确定',
              // cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              console.log('关闭弹窗');
            }).catch(() => {
              // 取消
            });
            return;
          }
          fn();
        }
      });
    };
    const deepForm = ref();
    const show = data => {
      console.log('data', data);
      if (!data.form) {
        form.value = {
          switch: 1,
          loginProtocol: 0,
          conditions: {
            andOr: '&&',
            conditions: [{
              dimension: 'version',
              symbol: undefined,
              value: ''
            }]
          }
        };
      } else {
        form.value = data.form;
        form.value.p || (form.value.p = []);
      }
      deepForm.value = JSON.parse(JSON.stringify(form.value));
      // oldVersion.value = data.oldVersion || 0;
      setRoot.value = data.setRoot || false;
      cname.value = data.cname || '';
      dialogVisible.value = true;
      type.value = data.type || 'channel';
      currentChannel.value = data.channel || '';
      typeTitle.value = data.typeTitle || 'switch';
      console.log('typeTitle', typeTitle.value);
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_switch = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_col = __unplugin_components_4;
      const _component_el_input = __unplugin_components_5;
      const _component_el_row = __unplugin_components_6;
      const _component_el_checkbox = __unplugin_components_7;
      const _component_el_checkbox_group = __unplugin_components_8;
      const _component_el_form = __unplugin_components_9;
      const _component_el_button = __unplugin_components_10;
      const _component_el_dialog = __unplugin_components_11;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: `${_unref(type) == 'batch' ? _unref(title) : `[${_unref(cname)}]渠道协议管理`}`,
        width: "600px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_11, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          ref_key: "comForm",
          ref: comForm,
          "label-width": "130px"
        }, {
          default: _withCtx(() => [!_unref(setRoot) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_withDirectives(_createVNode(_component_el_form_item, {
            label: "协议弹窗开关"
          }, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_u_question, {
              content: "首次启动游戏时出现协议弹窗，同意后才能进入游戏”"
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: _unref(form).switch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).switch = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 512), [[_vShow, _unref(type) != 'batch' || _unref(type) == 'batch' && _unref(typeTitle) == 'switch']]), _withDirectives(_createVNode(_component_el_form_item, {
            label: "登录协议开关"
          }, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_u_question, {
              style: {
                "margin-right": "10px"
              },
              content: "登录弹窗显示登录协议，勾选同意后才能进行登录"
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: _unref(form).loginProtocol,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).loginProtocol = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 512), [[_vShow, ['ultra', 'iultra'].includes(_unref(currentChannel))]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).conditions.conditions, item => {
            return _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
              key: item.dimension
            }, {
              label: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_u_question, {
                content: "生效条件增加提示“用于控制指定版本可,不填写默认全版本生效”"
              })])]),
              default: _withCtx(() => [_createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 8
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: item.symbol,
                    "onUpdate:modelValue": $event => item.symbol = $event,
                    placeholder: "条件",
                    style: {
                      "width": "80px",
                      "min-width": "80px"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_option, {
                      value: ">="
                    }, {
                      default: _withCtx(() => [_createTextVNode(" >= ")]),
                      _: 1
                    }), _createVNode(_component_el_option, {
                      value: "="
                    }, {
                      default: _withCtx(() => [_createTextVNode(" = ")]),
                      _: 1
                    }), _createVNode(_component_el_option, {
                      value: "<="
                    }, {
                      default: _withCtx(() => [_createTextVNode(" <= ")]),
                      _: 1
                    })]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  span: 16
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: item.value,
                    "onUpdate:modelValue": $event => item.value = $event,
                    placeholder: "输入游戏版本号"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1536)), [[_vShow, _unref(type) != 'batch' || _unref(type) == 'batch' && _unref(typeTitle) == 'switch']]);
          }), 128))], 64)) : _createCommentVNode("", true), _unref(setRoot) || _unref(typeTitle) == 'batchRoot' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "权限开关"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: _unref(form).swPermission,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).swPermission = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(setRoot) || _unref(typeTitle) == 'batchRoot' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "选择权限"
          }, {
            default: _withCtx(() => [__props.permissionList.length > 0 ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
              key: 0,
              modelValue: _unref(form).p,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).p = $event)
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.permissionList, item => {
                return _openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [_createVNode(_component_el_checkbox, {
                  label: item.id
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                  _: 2
                }, 1032, ["label"])]);
              }), 128))])]),
              _: 1
            }, 8, ["modelValue"])) : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无权限"))]),
            _: 1
          })) : _createCommentVNode("", true), _unref(typeTitle) === 'agreement' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(switchForm).privateSwitch,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(switchForm).privateSwitch = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("隐私协议")]),
            _: 1
          }, 8, ["modelValue"]), _unref(switchForm).privateSwitch ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "协议名称",
            prop: "priAgrName",
            rules: [{
              required: true,
              message: '请输入隐私协议名称',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).priAgrName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).priAgrName = $event),
              placeholder: "请输入隐私协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "协议地址",
            help: "部署相对路径/p/per_adu.html",
            prop: "priAgrUrl",
            rules: [{
              required: true,
              message: '请输入隐私协议地址',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).priAgrUrl,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).priAgrUrl = $event),
              placeholder: "请输入隐私协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_checkbox, {
            modelValue: _unref(switchForm).userSwitch,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(switchForm).userSwitch = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("用户协议")]),
            _: 1
          }, 8, ["modelValue"]), _unref(switchForm).userSwitch ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            label: "协议名称",
            prop: "userAgrName",
            rules: [{
              required: true,
              message: '请输入用户协议名称',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).userAgrName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).userAgrName = $event),
              placeholder: "请输入用户协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "协议地址",
            prop: "userAgrUrl",
            rules: [{
              required: true,
              message: '请输入用户协议地址',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).userAgrUrl,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).userAgrUrl = $event),
              placeholder: "请输入用户协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_checkbox, {
            modelValue: _unref(switchForm).childSwitch,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(switchForm).childSwitch = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("儿童协议")]),
            _: 1
          }, 8, ["modelValue"]), _unref(switchForm).childSwitch ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createVNode(_component_el_form_item, {
            label: "协议名称",
            prop: "childAgrName",
            rules: [{
              required: true,
              message: '请输入儿童协议名称',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).childAgrName,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).childAgrName = $event),
              placeholder: "请输入儿童协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "协议地址",
            help: "部署相对路径/p/per_child.html",
            prop: "childAgrUrl",
            rules: [{
              required: true,
              message: '请输入儿童协议地址',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).childAgrUrl,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).childAgrUrl = $event),
              placeholder: "请输入儿童协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) && _unref($channel).OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 3,
            modelValue: _unref(switchForm).sdkAgrSwitch,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(switchForm).sdkAgrSwitch = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("平台协议（android渠道生效）")]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true), _unref(switchForm).sdkAgrSwitch && _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) && _unref($channel).OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [_createVNode(_component_el_form_item, {
            label: "协议名称",
            prop: "sdkAgrName",
            rules: [{
              required: true,
              message: '请输入平台协议名称',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).sdkAgrName,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).sdkAgrName = $event),
              placeholder: "请输入平台协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "协议地址",
            prop: "sdkAgrUrl",
            help: "部署相对路径/p/all_sdk.html",
            rules: [{
              required: true,
              message: '请输入平台协议地址',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).sdkAgrUrl,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).sdkAgrUrl = $event),
              placeholder: "请输入平台协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) && _unref($channel).GLOBAL_OFFICIAL_CHANNEL !== _unref(currentChannel) ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 5,
            modelValue: _unref(switchForm).logoffSwitch,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(switchForm).logoffSwitch = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("注销协议（国内渠道生效）")]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true), _unref(switchForm).logoffSwitch && _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) && _unref($channel).GLOBAL_OFFICIAL_CHANNEL !== _unref(currentChannel) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [_createVNode(_component_el_form_item, {
            label: "协议名称",
            prop: "woffAgrName",
            rules: [{
              required: true,
              message: '请输入平台协议地址',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).woffAgrName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).woffAgrName = $event),
              placeholder: "请输入注销协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "协议地址",
            prop: "woffAgrUrl",
            help: "部署相对路径/p/all_sdk.html",
            rules: [{
              required: true,
              message: '请输入平台协议地址',
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).woffAgrUrl,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).woffAgrUrl = $event),
              placeholder: "请输入注销协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref(switchForm).logoffSwitch && (_unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL === _unref(currentChannel) || _unref($channel).GLOBAL_OFFICIAL_CHANNEL === _unref(currentChannel)) ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 如需配置海外渠道的注销协议，请前往「官方全球渠道配置」下的「协议配置」 ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !_unref(setRoot) && _unref(typeTitle) !== 'agreement' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [_unref(type) != 'batch' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "隐私协议名称",
            prop: "priAgrName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).priAgrName,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).priAgrName = $event),
              placeholder: "请输入隐私协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "隐私协议地址",
            help: "部署相对路径/p/per_adu.html",
            prop: "priAgrUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).priAgrUrl,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(form).priAgrUrl = $event),
              placeholder: "请输入隐私协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref(type) != 'batch' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            label: "用户协议名称",
            prop: "userAgrName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).userAgrName,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _unref(form).userAgrName = $event),
              placeholder: "请输入用户协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "用户协议地址",
            prop: "userAgrUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).userAgrUrl,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(form).userAgrUrl = $event),
              placeholder: "请输入用户协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref(type) != 'batch' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createVNode(_component_el_form_item, {
            label: "儿童协议名称",
            prop: "childAgrName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).childAgrName,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => _unref(form).childAgrName = $event),
              placeholder: "请输入儿童协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "儿童协议地址",
            help: "部署相对路径/p/per_child.html",
            prop: "childAgrUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).childAgrUrl,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(form).childAgrUrl = $event),
              placeholder: "请输入儿童协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref(type) != 'batch' && _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) && _unref($channel).OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 3
          }, [_createVNode(_component_el_form_item, {
            label: "平台协议名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).sdkAgrName,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _unref(form).sdkAgrName = $event),
              placeholder: "请输入平台协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "平台协议地址",
            help: "部署相对路径/p/all_sdk.html"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).sdkAgrUrl,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _unref(form).sdkAgrUrl = $event),
              placeholder: "请输入平台协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _unref(type) != 'batch' && _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL !== _unref(currentChannel) && _unref($channel).GLOBAL_OFFICIAL_CHANNEL !== _unref(currentChannel) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [_createVNode(_component_el_form_item, {
            label: "注销协议名称",
            prop: "woffAgrName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).woffAgrName,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(form).woffAgrName = $event),
              placeholder: "请输入注销协议名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "注销协议地址",
            prop: "woffAgrUrl",
            help: "部署相对路径/p/all_sdk.html"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).woffAgrUrl,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => _unref(form).woffAgrUrl = $event),
              placeholder: "请输入注销协议地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});